import React from "react";

interface EmailProps {
    email?: string;
    domain?: string;
}

const EmailButton: React.FC<EmailProps> = ({email, domain}) => {
    return (
        <a className="h-full min-w-[30px] max-w-[30px] flex items-center place-content-center" href={`mailto:${email}${domain ? '@' + domain : ''}`}>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="w-4 h-4">
                <path strokeLinecap="round" d="M16.5 12a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zm0 0c0 1.657 1.007 3 2.25 3S21 13.657 21 12a9 9 0 10-2.636 6.364M16.5 12V8.25"/>
            </svg>
        </a>
    );
}
export default EmailButton;
